import { Order } from '../order';

import { IOrder, IOrderData } from '../order.types';

export const mockOrdersData: IOrderData[] = [
  {
    series: '1000011111',
    customer_num: 'AGR0040',
    delcode: null,
    cotp: null,
    currency: 'USD',
    refb: null,
    eono: null,
    created_at: '2021-03-04T17:04:12.140622Z',
    updated_at: '2021-03-04T17:04:12.140642Z'
  },
  {
    series: '1000001',
    customer_num: 'AGA0001',
    delcode: null,
    cotp: null,
    currency: 'USD',
    refb: 'J1000176',
    eono: null,
    created_at: '2021-09-13T17:48:35.617941Z',
    updated_at: '2021-09-13T17:48:35.617964Z'
  }
];

export const mockOrders = (data: IOrderData[] = mockOrdersData): IOrder[] =>
  data.map(order => new Order(order));
